import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const CouponsPage = lazy(() => import('@/pages/coupons'));

export const Route = createFileRoute('/coupons')({
  component: function CouponsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <CouponsPage />
      </Suspense>
    );
  },
});
